/**
 * External Dependencies
 */

//import './components/nav';
//import './components/carousel';
//import './components/accordion';
//import './components/hero';
import './components/carousel';
import './components/contact-block';
import './components/contact-page';
import './components/developer-carousel';
import './components/hero';
import './components/image-and-text';
import './components/listing-carousel';
import './components/listing-search';
import './components/logo-showcase';
import './components/our-listings';
import './components/our-services-tab-list';
import './components/overlapped-background-image';
import './components/socials-card';
import './components/subscribe';
import './components/testimonial-carousel';
import './partials/checkbox';
import './partials/header';
import './views/author';
import './views/single-properties';
import AOS, { refresh } from "aos";

AOS.init();

setTimeout(() => {AOS>refresh();}, 500);
